import { apiClient } from './request';
import { create, fromJson, type JsonValue, toJson } from '@bufbuild/protobuf';
import {
  type SandboxSpec,
  SandboxSpecSchema,
  type SandboxEnvironment,
  SandboxEnvironmentSchema,
} from '@/proto/agentplatform/v1/sandbox_pb';
import {
  ListSandboxSpecsResponseSchema,
  GetSandboxSpecRequestSchema,
  GetSandboxSpecResponseSchema,
  ListSandboxEnvironmentsResponseSchema,
  GetSandboxEnvironmentRequestSchema,
  GetSandboxEnvironmentResponseSchema,
} from '@/proto/agentplatform/httpv2/sandbox_pb';
import { type ListRequest, ListRequestSchema } from '@/proto/agentplatform/httpv2/common_pb';

/** 列表返回的通用形状，兼容页面既有的 `data.data` / `data.total` 读法。 */
export interface SandboxSpecListResult {
  data: SandboxSpec[];
  total: number;
}

export interface SandboxEnvironmentListResult {
  data: SandboxEnvironment[];
  total: number;
}

export const sandboxConfigApi = {
  listSandboxSpecs: async (params: ListRequest): Promise<SandboxSpecListResult> => {
    const req = create(ListRequestSchema, {
      page: params.page,
      pageSize: params.pageSize,
      filter: params.filter,
      fuzzy: params.fuzzy,
      orderBy: params.orderBy,
    });
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/ListSandboxSpecs',
      toJson(ListRequestSchema, req)
    );
    const resp = fromJson(ListSandboxSpecsResponseSchema, responseObject.data);
    return { data: resp.data?.items ?? [], total: resp.data?.total ?? 0 };
  },

  getSandboxSpec: async (id: string): Promise<SandboxSpec> => {
    const req = create(GetSandboxSpecRequestSchema, { id });
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/GetSandboxSpec',
      toJson(GetSandboxSpecRequestSchema, req)
    );
    const resp = fromJson(GetSandboxSpecResponseSchema, responseObject.data);
    return resp.data ?? create(SandboxSpecSchema, {});
  },

  listSandboxEnvironments: async (params: ListRequest): Promise<SandboxEnvironmentListResult> => {
    const req = create(ListRequestSchema, {
      page: params.page,
      pageSize: params.pageSize,
      filter: params.filter,
      fuzzy: params.fuzzy,
      orderBy: params.orderBy,
    });
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/ListSandboxEnvironments',
      toJson(ListRequestSchema, req)
    );
    const resp = fromJson(ListSandboxEnvironmentsResponseSchema, responseObject.data);
    return { data: resp.data?.items ?? [], total: resp.data?.total ?? 0 };
  },

  getSandboxEnvironment: async (id: string): Promise<SandboxEnvironment> => {
    const req = create(GetSandboxEnvironmentRequestSchema, { id });
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/GetSandboxEnvironment',
      toJson(GetSandboxEnvironmentRequestSchema, req)
    );
    const resp = fromJson(GetSandboxEnvironmentResponseSchema, responseObject.data);
    return resp.data ?? create(SandboxEnvironmentSchema, {});
  },
};
